import _ from 'lodash';
import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import FormCheckbox from '../form/FormCheckbox';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import SectionHeader from '../SectionHeader';
import { isLocalhost } from '../../util';

const styles = () => {
	return {};
};

class PermissionPicker extends PureComponent {
	render() {
		const { label, value, path, onChange, disabled, error, helpText } = this.props;

		const permissions = [
			{
				id: 'canAddAndUpdateUsers',
				display: 'Can add and update Sphere users',
			},
			{
				id: 'canAddAndUpdateTicketSettings',
				display: 'Can add and update all ticket related settings',
			},
			{
				id: 'canAuthorizeBrowserForDriverLogin',
				display: 'Can authorize a browser for driver login',
			},
			{
				id: 'canUpdateScheduling',
				display: 'Can view/modify schedule for supervised employees',
			},
			{
				id: 'canViewAccounting',
				display: 'Can view accounting section and run reports',
			},
			{
				id: 'canViewTimeClocks',
				display: 'Can view time clocks section and shift reports',
			},
			{
				id: 'canUpdateTimeClockPermissions',
				display: 'Can update supervisor permission settings',
			},
			{
				id: 'canExportTimeClockInformation',
				display: 'Can export time shifts',
			},
			{
				id: 'canOverrideScheduleAssignments',
				display: 'Can add new drivers to the schedule',
			},
			{
				id: 'canRunTimeClockAudit',
				display: 'Can run Time Clock Audit',
			},
			{
				id: 'canRunAttendanceReports',
				display: 'Can run Driver Attendance Reports',
			},
			{
				id: 'canViewScheduledPto',
				display: 'Can view PTO that must be filled out due to schedule.',
			},
			{
				id: 'canViewLateAnalysis',
				display: 'Can view the late analysis reports.',
			},
			{
				id: 'canSendMobileNotifications',
				display: 'Can send mobile notifications to drivers',
			},
			{
				id: 'canBetaGeniusScan',
				display: 'Can Sphere Mobile user BETA the new Genius Scan Document Scanner',
			},
		];

		if (isLocalhost) {
			permissions.push({
				id: 'canUpdateJourneyPlans',
				display: 'Can add and update journey plans.',
			});
		}

		const hasError = !!error;
		const options = _.sortBy(permissions, 'display').map((permission) => {
			const { id, display } = permission;
			return { id, display };
		});

		return (
			<Fragment>
				<SectionHeader label={label} gridProps={{ xs: 12 }} />
				<Grid item xs={12}>
					<FormControl fullWidth={true} error={hasError} disabled={disabled} margin={'dense'}>
						<Grid container spacing={2}>
							{options.map(({ id, display }) => {
								const childPath = `${path}.${id}`;
								return (
									<Grid item xs={12} sm={6} key={childPath}>
										<FormCheckbox
											path={childPath}
											label={display}
											value={id}
											checked={!!value[id]}
											onChange={onChange}
										/>
									</Grid>
								);
							})}
						</Grid>
						{hasError && <FormHelperText>{error}</FormHelperText>}
						{helpText && !hasError && <FormHelperText>{helpText}</FormHelperText>}
					</FormControl>
				</Grid>
			</Fragment>
		);
	}
}

PermissionPicker.propTypes = {
	label: PropTypes.string,
	value: PropTypes.object.isRequired,
	path: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	error: PropTypes.string,

	classes: PropTypes.object,
	md: PropTypes.number,
	helpText: PropTypes.string,
};

PermissionPicker.defaultProps = {
	md: 12,
	label: 'Sphere Permissions',
};

export default _.flow([withStyles(styles)])(PermissionPicker);
